

export const UserBookCreativeGuide = ({ onNextStep = f => f, onCancel = f => f }) => {
    return (
        <div className="step inner guideStep">
            <div className="row">
                <div className="col6 col-md-12 guideImage">
                    <img src={`${process.env.PUBLIC_URL}/static/images/userbook/hello_bookgomi.gif`} alt="작품 새로만들기 안내" />
                </div>
                <div className="col6 col-md-12">
                    <div className="guideBox">
                        <h3 className="title">창작 작품 기준</h3>
                        <ol>
                            <li>창작동화, 2차 창작, 일기에 해당합니다.</li>
                            <li>창작작품은 <span>인기작품</span>에 올라갈 수 있습니다.</li>
                            <li>비창작인데, 창작작품으로 신청할시 <span>&lt;주의&gt;</span> 7일을 받습니다.</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div data-aos="fade-zoom-in" data-aos-delay="1000" data-aos-duration="1000">
                <button className="btn _blue" onClick={(e) => onNextStep('Y', 3)}>동의 합니다.</button>
                &nbsp;
                <button className="btn _gray" onClick={onCancel}>취소</button>
            </div>
        </div>
    );
}
